export default {"src":"/_next/static/media/DownArrow.fb5718c9.svg","height":8,"width":12,"blurWidth":0,"blurHeight":0};